import { Injectable } from "@nestjs/common";
import { AssetLicense } from "./asset-license.entity";
import { AssetLicenseDto } from "../dto/asset-license.dto";

@Injectable()
export class AssetLicenseAdapter{
    public convertDtotoAssetLicenseEntity(assetTransfersDto:AssetLicenseDto,isUpdate: boolean = false) : AssetLicense{
        const assetLicense = new AssetLicense();
        assetLicense.licenseId = assetTransfersDto.licenseId;
        assetLicense.licenseName = assetTransfersDto.licenseName;
        assetLicense.referenceNumber = assetTransfersDto.referenceNumber;
        assetLicense.company = assetTransfersDto.company;
        assetLicense.licenseNumber = assetTransfersDto.licenseNumber;
        assetLicense.responsibility = assetTransfersDto.responsibility;
        assetLicense.expiryDate = assetTransfersDto.expiryDate;
        // // assetLicense.isActive = assetTransfersDto.isActive;
        // assetLicense.createdAt = assetTransfersDto.createdAt;
        // assetLicense.createdUser = assetTransfersDto.createdUser;
        // assetLicense.updatedAt = assetTransfersDto.updatedAt;
        // assetLicense.updatedUser = assetTransfersDto.updatedUser;
        assetLicense.versionFlag = assetTransfersDto.versionFlag;
        assetLicense.renewalPersonName=assetTransfersDto.renewalPersonName;
        assetLicense.renewalStartDate= assetTransfersDto.renewalStartDate;
        assetLicense.renewalExpiryDate= assetTransfersDto.renewalExpiryDate;
        assetLicense.plantId = assetTransfersDto.plantId;
        assetLicense.isActive=assetTransfersDto.isActive==undefined?true:assetTransfersDto.isActive;
        if (isUpdate) {
            assetLicense.updatedUser = assetTransfersDto.updatedUser;
        } else {
            assetLicense.isActive = true;
            assetLicense.createdUser =assetTransfersDto.createdUser;
        }

        return assetLicense;

    }
   
    public convertEntitytoAssetLicenseDto(assetLicense:AssetLicense) : AssetLicenseDto{
        const assetLicenseDto = new AssetLicenseDto();
        assetLicenseDto.licenseId = assetLicense.licenseId;
        assetLicenseDto.licenseName = assetLicense.licenseName;
        assetLicenseDto.referenceNumber = assetLicense.referenceNumber;
        assetLicenseDto.company = assetLicense.company;
        assetLicenseDto.licenseNumber = assetLicense.licenseNumber;
        assetLicenseDto.responsibility = assetLicense.responsibility;
        assetLicenseDto.expiryDate = assetLicense.expiryDate;
        assetLicenseDto.isActive = assetLicense.isActive;
        assetLicenseDto.createdAt = assetLicense.createdAt;
        assetLicenseDto.createdUser = assetLicense.createdUser;
        assetLicenseDto.updatedAt = assetLicense.updatedAt;
        assetLicenseDto.updatedUser = assetLicense.updatedUser;
        assetLicenseDto.versionFlag = assetLicense.versionFlag;
        assetLicenseDto.renewalPersonName = assetLicense.renewalPersonName;
        assetLicenseDto.renewalStartDate = assetLicense.renewalStartDate;
        assetLicenseDto.renewalExpiryDate = assetLicense.renewalExpiryDate;
        assetLicenseDto.plantId= assetLicense.plantId;
      
        return assetLicenseDto;

    }

 
}